import { Routes } from '@angular/router';
import { SaneProjectCalculatorComponent } from './pages/sane-project-calculator/sane-project-calculator.component';
import { SaneProjectEditComponent } from './pages/sane-project-edit/sane-project-edit.component';
import { SaneProjectResumeComponent } from './pages/sane-project-resume/sane-project-resume.component';
import { SaneProjectSearchComponent } from './pages/sane-project-search/sane-project-search.component';

export const SaneProjectRoutes = [
  {
    path: 'projects',
    title: $localize`:@@app.route.projects:Programas de Previsión Social Individual`,
    data: {
      linkText: $localize`:@@app.route.projects:Programas`
    },
    children: []
  },
  {
    path: 'sane-projects',
    title: $localize`:@@app.route.sane-projects:Programas de Previsión Social Individual SANE`,
    data: {
      icon: 'diversity_2',
      linkText: $localize`:@@app.route.sane-projects:SANE`
    },
    children: [
      {
        path: 'edit',
        component: SaneProjectEditComponent,
        title: $localize`:@@app.route.sane-projects.new:Nuevo Programa de Previsión Social Individual SANE`,
        data: {
          linkText: $localize`:@@app.route.sane-projects.new:Nuevo`
        }
      },
      {
        path: 'edit/:id',
        component: SaneProjectEditComponent,
        title: $localize`:@@app.route.sane-projects.edit:Edición Programa de Previsión Social Individual SANE`
      },
      {
        path: 'calculator',
        component: SaneProjectCalculatorComponent,
        title: $localize`:@@app.route.sane-projects.calculator:Tarificador`
      },
      {
        path: 'resume',
        component: SaneProjectResumeComponent,
        title: $localize`:@@app.route.sane-projects.resume:Resumen`
      },
      {
        path: 'search',
        component: SaneProjectSearchComponent,
        title: $localize`:@@app.route.sane-projects.search:Consulta Programas de Previsión Social Individual SANE`,
        data: {
          linkText: $localize`:@@app.route.sane-projects.search:Consulta`
        }
      }
    ]
  }
] as Routes;
